import React from "react";
import { Button } from "../utils/Button";

export const CallToActionBanner = ({ att, buttonColor }) => {
  return (
    <div className={`${att} rounded-3xl p-6 my-4`}>
      <p className="pb-6 text-[28px] text-center  max-w-7xl mx-auto w-full md:w-1/2">
        Unlock full-access and start designing better user experiences today
      </p>
      <div className="w-full md:w-fit mx-auto rounded-xl ">
        <Button att={`${buttonColor} rounded-xl w-full px-5 py-6`} name={"Let's do this"} />
      </div>
    </div>
  );
};
